import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function StickyCtaBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-295">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white/90 backdrop-blur-md border-t border-soft-sage/30 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] md:hidden" data-id="element-296">
          <div className="flex items-center justify-between max-w-md mx-auto" data-id="element-297">
            <div className="flex flex-col" data-id="element-298">
              <span className="text-xs text-muted font-medium uppercase tracking-wider" data-id="element-299">
                Limited Offer
              </span>
              <div className="flex items-baseline gap-2" data-id="element-300">
                <span className="text-navy font-bold text-xl" data-id="element-301">$6.36</span>
                <span className="text-muted text-sm line-through" data-id="element-302">$17</span>
              </div>
            </div>
            <a href="https://www.betterbysteps.com/cart/44200151777373:1" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center px-6 py-3 bg-navy text-white font-bold rounded-full text-sm shadow-md hover:bg-navy/90 transition-colors" data-id="element-303">
              Get the Binder
              <ArrowRight className="ml-1.5 w-4 h-4" data-id="element-304" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}